module.exports = __webpack_public_path__ + "img/meditations.c3ef7b07.png";